export const queryParams2Facets = queries =>
  queries
    ? queries
        .split('?')[1]
        .replace(/=/g, ':')
        .split('&')
    : [];

export const insertUrlParam = (facets) => {
  if (window.history.pushState) {
    const searchParams = facets?.length
      ? `?${facets.join('&').replace(/:/g, '=')}`
      : '';
    const newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}${searchParams || ''}`;
    window.history.pushState({ path: newurl }, '', newurl);
  }
};

export const queryParamsObject2String = (params={}) => {
  const paramStr = [];
  if (Object.keys(params).length > 0){
    Object.keys(params).forEach(param => {
      paramStr.push(`${param}=${params[param]}`)
    });
    return `?${paramStr.join('&')}`;
  }
  return '';
};
